import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import App from './App';
import { QueryProvider } from './providers/QueryProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { consumerTheme } from './theme/antd-theme.config';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <ConfigProvider theme={consumerTheme}>
          <App />
        </ConfigProvider>
      </QueryProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
